const EVENT_NAMES = ["add", "remove"] as const;

type EventName = (typeof EVENT_NAMES)[number];

type EventData<T extends object> = T[];

type Listener<T extends object> = (data: EventData<T>) => void;

export const createEmitter = <T extends object>() => {
    const listeners = EVENT_NAMES.reduce(
        (acc, name) => {
            acc[name] = [];
            return acc;
        },
        {} as Record<EventName, Listener<T>[]>,
    );

    const emit = (name: EventName, data: EventData<T>) => {
        listeners[name].forEach((listener) => listener(data));
    };

    const on = (name: EventName, listener: Listener<T>) => {
        listeners[name].push(listener);
    };

    const off = (name: EventName, listener: Listener<T>) => {
        const index = listeners[name].indexOf(listener);

        if (index !== -1) {
            listeners[name].splice(index, 1);
        }
    };

    return { emit, on, off };
};
